import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ServicioSection } from './components/ServicioSection';
import { Testimonios } from './components/Testimonios';
import { Contacto } from './components/Contacto';
import { Footer } from './components/Footer';
import { TawkToWidget } from './components/TawkToWidget';
import { GoogleTagManager } from './components/GoogleTagManager';
import { servicios } from './data/servicios';
export function App() {
  return <div className="min-h-screen w-full bg-[#0D0D0D] font-sans" data-id="element-0" data-mp="2mmlsv0ftlx2o">
      <Header data-id="element-1" data-mp="2mjzplczyq3q9" />
      <main data-id="element-2" data-mp="31agoopp4khjz">
        <Hero data-id="element-3" data-mp="31ayry6a7fw1e" />
        {servicios.map(servicio => <ServicioSection key={servicio.id} servicio={servicio} data-id="element-4" data-mp="31ctbbg5tvg3d" />)}
        <Testimonios data-id="element-5" data-mp="2wifh3h2wjf0a" />
        <Contacto data-id="element-6" data-mp="2wi5n7ieqknpb" />
      </main>
      <Footer data-id="element-7" data-mp="28tw5arkn8k3g" />
      <TawkToWidget data-id="element-8" data-mp="28te198rqp1kz" />
      <GoogleTagManager data-id="element-9" data-mp="28sutgkvsztko" />
    </div>;
}